export default __webpack_public_path__ + "static/media/tyler.eeb5965b.png";